"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generate = void 0;
var defaultFormaterFunc_1 = require("./defaultFormaterFunc");
var generatePlaylists_1 = require("./generatePlaylists");
var DEFAULT_CONFIG = {
    forcePlaylistLength: false,
    numberOfPlaylists: 1,
    formaterFunc: defaultFormaterFunc_1.defaultFormaterFunc,
    consoleOutput: false,
};
var generate = function (params) {
    if (params === void 0) { params = {}; }
    return __awaiter(void 0, void 0, void 0, function () {
        var config, generationSettings, rotations, result, rotationIdItterator, formater, rotations_1, rotations_1_1, rotation, formaterResult, e_1_1;
        var e_1, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4, getConfig(params)];
                case 1:
                    config = _b.sent();
                    return [4, getGenerationSettings(params)];
                case 2:
                    generationSettings = _b.sent();
                    return [4, (0, generatePlaylists_1.generatePlaylists)(generationSettings, config.numberOfPlaylists)];
                case 3:
                    rotations = _b.sent();
                    result = [];
                    rotationIdItterator = 1;
                    formater = config.formaterFunc;
                    _b.label = 4;
                case 4:
                    _b.trys.push([4, 10, 11, 12]);
                    rotations_1 = __values(rotations), rotations_1_1 = rotations_1.next();
                    _b.label = 5;
                case 5:
                    if (!!rotations_1_1.done) return [3, 9];
                    rotation = rotations_1_1.value;
                    rotation.id = rotationIdItterator;
                    rotationIdItterator += 1;
                    if (!formater) return [3, 7];
                    return [4, formater(rotation)];
                case 6:
                    formaterResult = _b.sent();
                    result.push(formaterResult);
                    return [3, 8];
                case 7:
                    result.push(rotation);
                    _b.label = 8;
                case 8:
                    rotations_1_1 = rotations_1.next();
                    return [3, 5];
                case 9: return [3, 12];
                case 10:
                    e_1_1 = _b.sent();
                    e_1 = { error: e_1_1 };
                    return [3, 12];
                case 11:
                    try {
                        if (rotations_1_1 && !rotations_1_1.done && (_a = rotations_1.return)) _a.call(rotations_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                    return [7];
                case 12:
                    if (config.consoleOutput) {
                        console.log(result);
                    }
                    return [2, result];
            }
        });
    });
};
exports.generate = generate;
var getConfig = function (params) {
    if (params === void 0) { params = {}; }
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2, (__assign(__assign({}, DEFAULT_CONFIG), params))];
        });
    });
};
var getGenerationSettings = function (params) {
    if (params === void 0) { params = {}; }
    return __awaiter(void 0, void 0, void 0, function () {
        var generationSettings;
        return __generator(this, function (_a) {
            if (params.generationSettings.settings) {
                generationSettings = params.generationSettings.settings;
            }
            else if (params.generationSettings.startTime) {
                generationSettings = params.generationSettings;
            }
            else {
                throw new Error("Generation data is not specified. Options generationSettings is empty");
            }
            if (Number.isInteger(params.forcePlaylistLength)) {
                generationSettings.numberMediafiles = params.forcePlaylistLength;
            }
            if (generationSettings.startTime) {
                return [2, generationSettings];
            }
            throw new Error("Generation Data is not correct");
        });
    });
};
//# sourceMappingURL=index.js.map